import React from 'react';
import styles from './EventPopup.scss';
import classNames from 'classnames/bind';
// import Countdown from 'react-countdown-now';
import CountDown from 'web/components/common/CountDown';

const cx = classNames.bind(styles);

const EventPopup = ({
  img = '',
  pcImg = '',
  handlePopupClose,
  handleSubmit,
  date = '',
}) => {
  const isMobile = window.isMobile;

  return (
    <div className={cx('EventPopup', isMobile === false ? 'pc' : '')}>
      <div className="popup-wrap">
        <div className="popup-close-btn" onClick={handlePopupClose}></div>
        <img src={isMobile ? img : pcImg} alt="event-popup-img" />

        {date ? (
          <div className="popup-count-wrap">
            &nbsp;
            <CountDown date={date} />
            &nbsp;
          </div>
        ) : null}
        {handleSubmit ? (
          <div className="popup-btn-wrap">
            <button className="popup-btn" onClick={handleSubmit}>
              {isMobile ? '' : '쿠폰받기'}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EventPopup;
